<template>
  <div>
    <p class="lib__text-info">{{ $t('resume.workAddress') }}</p>
    <p>
      <span v-if="address.isMapLocation">
      <span class="lib__text-weight-600">LAT {{ address.mapLocation.lat }} </span><br />
      <span class="lib__text-weight-600">LNG {{ address.mapLocation.lng }}</span>
      </span>
      <span v-else>
        <span class="lib__text-weight-600">  {{ address.streetSubCity.name }} {{ address.houseNumber }} </span>
      </span>
      <br />
      <span class="lib__text-weight-600"> {{ address.subCity.zipCode }} {{ address.subCity.cityName }} </span>
    </p>
    <p class="lib__text-info">{{ $t('resume.buildingType') }} :</p>
    <p>
      <span class="lib__text-weight-600" v-html="buildingType.valueOf() === 'house' ? $t('new-connection-cmh.address-step.singleFamilyHome') : $t('new-connection-cmh.address-step.building')"></span>
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AddressPoint } from '@/models';
import { BuildingType } from '@/models/building-type';

@Component({
  name: 'resume-address-cmh-mobile'
})
export default class ResumeAddressCmhMobile extends Vue {
  @Prop({ type: Object, required: true }) public readonly address!: AddressPoint
  @Prop({ type: String, required: true }) public readonly buildingType!: BuildingType
}
</script>

<style scoped>

</style>